import { IRemoteConfigPayload } from './remote-config.types';

/**
 * Estado de módulo, e não um serviço injetável, porque `url()` em
 * `src/environments/environment.ts` é uma função livre — não há DI que a
 * alcance. É preenchido uma vez, antes do `bootstrapApplication`.
 */
let atual: IRemoteConfigPayload['config'] | null = null;

export function aplicarConfig(payload: IRemoteConfigPayload): void {
  atual = payload.config;
}

function exigirConfig(): IRemoteConfigPayload['config'] {
  if (!atual) {
    throw new Error('[remote-config] uso antes de o bootstrap ter aplicado a configuração');
  }
  return atual;
}

/**
 * Lança em vez de devolver undefined: sem isto, uma chave ausente viraria a
 * string "undefined" no meio da URL (o `url()` concatena cru) e o sintoma
 * chegaria como um erro de rede sem relação aparente com configuração.
 */
export function resolverHost(chave: string): string {
  const host = exigirConfig().hosts[chave];
  if (!host) throw new Error(`[remote-config] host não configurado: "${chave}"`);
  return host;
}

export const resolverUrls = () => exigirConfig().urls;
export const resolverExternalUrls = () => exigirConfig().externalUrls;
export const resolverBraspag = () => exigirConfig().braspag;
export const resolverSuccessCodes = () => exigirConfig().successCodesCheckout;
